import {gql} from 'apollo-boost'
export const IMPORT_BORROWERS = gql`
  mutation importBorrowers($meta: MetaImportInput!, $payload: [BorrowerInput]) {
    importBorrowers(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`
export const IMPORT_BORROWERS_UPDATE = gql`
  mutation importBorrowersUpdate($meta: MetaImportInput!, $payload: [BorrowerInput]) {
    importBorrowersUpdate(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`
export const GET_BORROWER = gql`
  query getBorrower($id: ID!) {
    getBorrower(
      id: $id
    ) {
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      studentCode
      issueDate
      expDate
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      degree{
        id
        nameTh
      }
      periodTerm
      periodYear
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
        curriculumDetails{
          loanType
          curriculumPeriod
          maximumLoanAmount
          contractPeriod
          paymentAmount
        }
      }
      career
      position
      affiliate
      studentCode
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      isExternal
      status
    }
  }
`
export const GET_BORROWER_FOR_BORROWER_SEARCH = gql`
  query getBorrower($id: ID!) {
    getBorrower(
      id: $id
    ) {
      id
      fullName
      idCardNumber
      studentCode
      phone
      mobile
      email
      contracts{
        id
        contractNo
        contractSeq
        contractDate
        contractCloseDate
        contractName
        contractAmount
        loanAmount
        principleRemain
        restructuring
        contractStatus
        agingNumber
        paymentDetail{
          paidFee
          paidPenalty
          paidInterest
          paidPrinciple
          balanceRemain
        }
        outstandingBalanceDetail{
          accruedFeeRemain
          accruedPenaltyRemain
          outstandingAmountRemain
        }
        contractSummarizeStatus
      }
      suretyContracts{
        id
        contractNo
        contractSeq
        contractDate
        contractCloseDate
        contractName
        contractAmount
        loanAmount
        principleRemain
        restructuring
        contractStatus
        agingNumber
        contractSummarizeStatus
      },
      borrowerEducationInformation{
        educationStatusName
      }
    }
  }
`
export const GET_BORROWERS = gql`
  query getBorrowers {
    getBorrowers{
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      idCardNumber
      studentCode
      period{
        id
      }
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
        curriculumDetails{
          loanType
          curriculumPeriod
          maximumLoanAmount
          contractPeriod
          paymentAmount
        }
      }
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const GET_BORROWERS_IS_UN_APPROVED = gql`
  query getBorrowersIsUnApproved {
    getBorrowersIsUnApproved{
      id
      projectName
      idCardNumber
      studentCode
      fullName
      externalApproved
      createdAt(local: true, format: "DD MMM YYYY เวลา HH.mm น.")
    }
  }
`
export const GET_BORROWERS_CREATED_BY_CURRENT_USER = gql`
  query getBorrowersCreatedByCurrentUser {
    getBorrowersCreatedByCurrentUser{
      id
      fullName
      idCardNumber
      studentCode
      period{
        id
      }
      project{
        id
        nameTh
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
        curriculumDetails{
          loanType
          curriculumPeriod
          maximumLoanAmount
          contractPeriod
          paymentAmount
        }
      }
      status
    }
  }
`
export const CREATE_BORROWER = gql`
  mutation createBorrower($payload: BorrowerInput) {
    createBorrower(
      payload: $payload
    ){
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      studentCode
      issueDate
      expDate
      nationality{
        id
        nameTh
      }
      career
      position
      affiliate
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      degree{
        id
        nameTh
      }
      period{
        id
        term
        year
        name
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
        curriculumDetails{
          loanType
          curriculumPeriod
          maximumLoanAmount
          contractPeriod
          paymentAmount
        }
      }
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const UPDATE_BORROWER = gql`
  mutation updateBorrower($id: ID!, $payload: BorrowerInput!) {
    updateBorrower(
      id: $id,
      payload: $payload
    ) {
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      studentCode
      issueDate
      expDate
      nationality{
        id
        nameTh
      }
      career
      position
      affiliate
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      degree{
        id
        nameTh
      }
      period{
        id
        term
        year
        name
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
        curriculumDetails{
          loanType
          curriculumPeriod
          maximumLoanAmount
          contractPeriod
          paymentAmount
        }
      }
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const DELETE_BORROWER = gql`
  mutation deleteBorrower($id: ID!) {
    deleteBorrower(
      id: $id
    ) {
      id
    }
  }
`
export const APPROVED_EXTERNAL_BORROWER = gql`
  mutation approvedExternalBorrower($id: ID!) {
    approvedExternalBorrower(
      id: $id
    ) {
      id
    }
  }
`

export const FORCE_DELETE_BORROWER = gql`
  mutation forceDeleteBorrower($id: ID!) {
    forceDeleteBorrower(
      id: $id
    ) {
      id
    }
  }
`
export const IMPORT_SURETIES = gql`
  mutation importSureties($meta: MetaImportInput!, $payload: [SuretyInput]) {
    importSureties(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`
export const IMPORT_SURETIES_UPDATE = gql`
  mutation importSuretiesUpdate($meta: MetaImportInput!, $payload: [SuretyInput]) {
    importSuretiesUpdate(
      meta: $meta
      payload: $payload
    ){
      success
      error
      errorMassage
    }
  }
`
export const GET_SURETY = gql`
  query getSurety($id: ID!) {
    getSurety(
      id: $id
    ) {
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      issueDate
      expDate
      nationality{
        id
        nameTh
      }
      career
      position
      affiliate
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const GET_SURETY_FOR_BORROWER_SEARCH = gql`
  query getSurety($id: ID!) {
    getSurety(
      id: $id
    ) {
      id
      fullName
      idCardNumber
      phone
      mobile
      email
      suretyContracts{
        id
        contractNo
        contractSeq
        contractDate
        contractName
        contractAmount
        loanAmount
        principleRemain
        restructuring
        contractStatus
        agingNumber
        contractSummarizeStatus
      }
    }
  }
`
export const GET_SURETIES = gql`
  query getSureties {
    getSureties{
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      idCardNumber
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const GET_SURETIES_CREATED_BY_CURRENT_USER = gql`
  query getSuretiesCreatedByCurrentUser {
    getSuretiesCreatedByCurrentUser{
      id
      fullName
      idCardNumber
      name
      surname
      idCardNumber
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const CREATE_SURETY = gql`
  mutation createSurety($payload: SuretyInput) {
    createSurety(
      payload: $payload
    ){
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      issueDate
      expDate
      nationality{
        id
        nameTh
      }
      career
      position
      affiliate
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const CREATE_SURETIES_BY_BORROWER = gql`
  mutation createSuretiesByBorrower{
    createSuretiesByBorrower{
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      issueDate
      expDate
      nationality{
        id
        nameTh
      }
      career
      position
      affiliate
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const UPDATE_SURETY = gql`
  mutation updateSurety($id: ID!, $payload: SuretyInput!) {
    updateSurety(
      id: $id,
      payload: $payload
    ) {
      id
      prefix{
        id
        nameTh
      }
      name
      surname
      birthDay
      idCardNumber
      issueDate
      expDate
      nationality{
        id
        nameTh
      }
      career
      position
      affiliate
      address{
        location
        houseNumber
        moo
        alley
        road
        subDistrict
        district
        province
        zipcode
        locationDoc
        houseNumberDoc
        mooDoc
        alleyDoc
        roadDoc
        subDistrictDoc
        districtDoc
        provinceDoc
        zipcodeDoc
      }
      phone
      mobile
      email
      actions{
        view
        visible
        create
        edit
        delete
      }
      status
    }
  }
`
export const DELETE_SURETY = gql`
  mutation deleteSurety($id: ID!) {
    deleteSurety(
      id: $id
    ) {
      id
    }
  }
`
export const FORCE_DELETE_SURETY = gql`
  mutation forceDeleteSurety($id: ID!) {
    forceDeleteSurety(
      id: $id
    ) {
      id
    }
  }
`

export const GET_BORROWER_OPTIONS = gql`
  query getBorrowerOptions {
    getBorrowers{
      id
      idCardNumber
      studentCode
      fullName
      status
    }
  }
`
export const GET_BORROWER_CONTRACT_OPTIONS = gql`
  query getBorrowers {
    getBorrowers{
      id
      fullName
      idCardNumber
      studentCode
      period{
        id
      }
      project{
        id
        nameTh
      }
      campus{
        id
        nameTh
      }
      curriculum{
        id
        curriculumNo
        nameTh
        faculty{
          id
          nameTh
        }
        curriculumDetails{
          loanType
          curriculumPeriod
          maximumLoanAmount
          contractPeriod
          paymentAmount
        }
      }
      status
    }
  }
`

export const GET_SURETY_OPTIONS = gql`
  query getSureties {
    getSureties{
      id
      idCardNumber
      fullName
      status
    }
  }
`
export const GET_SURETY_FILTER_OPTIONS = gql`
  query getSuretiesByFilters($payload: SuretyFiltersInput) {
    getSuretiesByFilters(
      payload: $payload
    ){
      id
      idCardNumber
      fullName
      status
    }
  }
`
export const GET_SURETY_CONTRACT_OPTIONS = gql`
  query getSureties {
    getSureties{
      id
      fullName
      idCardNumber
      status
    }
  }
`
